/* NEXブログテンプレートでのみ利用するJS処理 */

// scrollify.js関連
$(function() {
  /* リサイズイベントは利用しない
  const resizeEvent = () => {
    var windowWidth = $(window).width();
    if(windowWidth > 1050){
      $.scrollify.enable();
    }else{
      $.scrollify.disable();
    }
  }
  */
  $.scrollify({
    section : ".blog-nez-article__section",
    sectionName : ".blog-nez-article__section",
    easing : 'easeInOutCubic',
    scrollSpeed : 800,
    afterResize:function(i) {
    },
    afterRender:function(i) {
      $.scrollify.current().find(".blog-nez-article__subtitle-list-wrapper").fadeIn(400).css('display','flex');;
    },
    after: function(i) {
      $(".blog-nez-article__subtitle-detail").removeClass("is-show");
    }
  });
});

// Intersection observerに伴う要素切り替え表示（blogのみ）
function showIndexChange (targetArray, index, style) {
  targetArray.forEach((item, i) => {
    if (i != index) {
      item.style.display = "none";
    } else {
      item.style.display = style;
    }
  })
}

// Intersection observerによる交差判定（blogのみ）
function createObserver() {
  const logoAray = document.querySelectorAll(".blog-nez-header__logo"),
        subtitleAray = document.querySelectorAll(".blog-nez-article__subtitle-list-wrapper"),
        sections = document.querySelectorAll(".blog-nez-article__section");

  let options = {
    rootMargin: "-10% 0px -70%",
    threshold: [0, 0.5, 1.0]
  };

  const callback = (entries) => {
    entries.forEach((entry) => {
      if (entry.intersectionRatio != 0) {
        showIndexChange(logoAray, entry.target.dataset.index, "block");
        showIndexChange(subtitleAray, entry.target.dataset.index, "flex");
      }
    });
  };

  let observer = new IntersectionObserver(callback, options);

  if(sections) {
    sections.forEach((section, index) => {
      section.dataset.index = index;
      observer.observe(section);
    });  
  }
}

// サブタイトル文言の詳細表示（blogのみ）
function subtitleDetail() {
  const subtitleListArray = document.querySelectorAll(".blog-nez-article__subtitle-list li");

  if(subtitleListArray) {
    subtitleListArray.forEach(item => {
      item.addEventListener("mouseenter", (event) => {
        event.target.querySelector(".blog-nez-article__subtitle-detail")?.classList.add("is-show")
      })
      item.addEventListener("mouseleave", (event) => {
        event.target.querySelector(".blog-nez-article__subtitle-detail")?.classList.remove("is-show")
      })

      // SP端末向け
      item.querySelector(".blog-nez-article__subtitle-text--link")?.addEventListener("touchstart", (event) => {
        // SP端末ではサブタイトル項目のリンク遷移を無効化する
        event.preventDefault();
      })

      item.addEventListener("touchstart", (event) => {
        document.querySelectorAll(".blog-nez-article__subtitle-detail")?.forEach((elseitem) => {
          elseitem.classList.remove("is-show")
        })
        document.querySelectorAll(".blog-nez-article__subtitle-text")?.forEach((elseitem) => {
          elseitem.classList.remove("selected")
        })
        item.querySelector(".blog-nez-article__subtitle-detail")?.classList.add("is-show")
        item.querySelector(".blog-nez-article__subtitle-text")?.classList.add("selected")
      })
      
    })
  }
}

// ヘッダーメニュー処理（blog & article共通）
function headerNavToggle() {
  const body = document.querySelector("body"),
        navigation = document.querySelector("#nezBlogHeaderNav"),
        openBtn = document.querySelector("#nezBlogHeaderNavBtn");

  openBtn.addEventListener("click", function(){
    body.classList.toggle("nav-open")
    navigation.classList.toggle("is-active")
    if (body.classList.contains("nav-open")) {
      $.scrollify.disable();
      categoryMenuOverflow();
    } else {
      $.scrollify.enable();
    }
  });
}

// カテゴリーメニュー処理（blog & article共通）
function categoryNavToggle() {
  const categoryParrentArray = document.querySelectorAll(".blog-nez-header__category-menu-title");
  if(categoryParrentArray) {
    categoryParrentArray.forEach(item => {
      item.addEventListener("click", (event) => {
        event.target.nextSibling?.classList.toggle("is-show")
        categoryMenuOverflow();
      })
    })
  }
}
function categoryMenuOverflow(){
  const categoryMenuArea = document.querySelector(".blog-nez-header__category"),
        categoryMenuList = document.querySelector(".blog-nez-header__category-menu"),
        categoryMenuArray = document.querySelectorAll(".blog-nez-header__category-menu-item");
  let categoryMenuHeight = 0;

  // PC版処理
  if (window.matchMedia("(min-width: 1001px)").matches) {

    let blankwidth = categoryMenuArea.clientWidth / 2;
  
    // メニュー領域の半分を余白として確保する
    // 余白を確保できない場合はCSSの追加制御によるスクロールを有効化する
    if(categoryMenuList.clientWidth > blankwidth) {
      categoryMenuArea.classList.add("is-overflow")
    }

  } else {
    // SP版処理
    // 領域よりメニュー項目の高さが大きい場合、CSSの追加制御を可能にする
    if(categoryMenuArray) {
      categoryMenuArray.forEach(item => {
        categoryMenuHeight = categoryMenuHeight + item.clientHeight;
      })
    }
    if (categoryMenuHeight > categoryMenuArea.clientHeight) {
      categoryMenuArea.classList.add("is-overflow")
    } else {
      categoryMenuArea.classList.remove("is-overflow")
    }
  }
}

// スライダー指定（articleのみ）
const swiper = new Swiper('.swiper', {
  // Optional parameters
  loop: true,
  lazy: true,
  slidesPerView: 2,
  spaceBetween: 5,
  speed: 800,
  runCallbacksOnInit: false,

  breakpoints: {
    768: {
      slidesPerView: 5,
      spaceBetween: 10
    }
  },

  // Navigation arrows
  navigation: {
    nextEl: '.slider-button--next',
    prevEl: '.slider-button--prev',
  }

});

// 関数実行
window.addEventListener("DOMContentLoaded", function () {
  headerNavToggle();
  categoryNavToggle();
})
window.addEventListener("load", function () {
  createObserver();
  subtitleDetail();
})
window.addEventListener("resize", function () {
  categoryMenuOverflow();
})